var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "screen", attrs: { id: "loginScreen" } },
    [
      _c(
        "transition",
        { attrs: { name: "fade", mode: "out-in", appear: "" } },
        [
          _c(
            "div",
            { staticClass: "main-login-container" },
            [
              _c("WeezieLogoSVG", { staticClass: "fibercloud-logo" }),
              _vm._v(" "),
              _c(
                "transition",
                { attrs: { name: "fadeLogin", mode: "out-in", appear: "" } },
                [
                  _c(
                    "div",
                    { staticClass: "loginContainer" },
                    [
                      _vm._t("title"),
                      _vm._v(" "),
                      _vm._t("form"),
                      _vm._v(" "),
                      _vm._t("button"),
                      _vm._v(" "),
                      _vm._t("remember-me-reset-password"),
                      _vm._v(" "),
                      _vm._t("logoutButton")
                    ],
                    2
                  )
                ]
              )
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c("hub-footer", {
        attrs: { loading: false, host: _vm.host, version: _vm.version }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-26084dc2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-26084dc2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Login.vue
// module id = null
// module chunks = 